import { withSentryRouting } from '@sentry/react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'

import WellPage from './WellPage'

const SentryRoute = withSentryRouting(Route)

export default function WellRoutes({ plateID }: { plateID: string }) {
  const match = useRouteMatch()

  return (
    <Switch>
      <SentryRoute
        exact
        path={match.path}
        render={({ match: { url } }) => (
          <Redirect to={url.split('/').slice(0, -1).join('/')} />
        )}
      />

      <SentryRoute
        exact
        path={`${match.path}/:pos`}
        render={({
          match: {
            params: { pos },
          },
        }) => <WellPage plateID={plateID} pos={pos} />}
      />
    </Switch>
  )
}
